import { User } from 'firebase/auth';
import { firestore } from '~/firebase/init';
import { doc, onSnapshot } from 'firebase/firestore';
import { SnapshotFn } from './type';

export function cartListener(platformId: string, cartId: string, onNext: SnapshotFn) {
  const ref = doc(firestore, `platforms`, platformId, 'carts', cartId);

  return onSnapshot(ref, {
    next: onNext,
    error: (err) => {
      console.error('listen cart error', err);
    },
  });
}
